import { BETA_SOURCE_OPTIONS } from "../constants/betaSignup.js";
import { isValidEmail } from "./emailValidation.js";

const SOURCE_OPTIONS = new Set(BETA_SOURCE_OPTIONS);

export function reflectingWordCount(text) {
  return String(text || "")
    .trim()
    .split(/\s+/)
    .filter(Boolean).length;
}

export function validateBetaSignupForm({
  fullName,
  email,
  source,
  sourceOther,
  reflectingOn,
  willingToFeedback,
  consent
}) {
  const errors = [];
  if (!String(fullName || "").trim()) errors.push("Full name is required.");
  if (!isValidEmail(email)) errors.push("A valid email is required.");
  if (!SOURCE_OPTIONS.has(source)) errors.push("Please select where you heard about Ahavibes.");
  if (source === "Other" && !String(sourceOther || "").trim()) {
    errors.push("Please specify how you heard about us.");
  }
  const reflectingTrimmed = String(reflectingOn || "").trim();
  if (!reflectingTrimmed || reflectingTrimmed.length < 3) {
    errors.push("Please share a little about what you want help reflecting on.");
  }
  if (willingToFeedback !== "yes") {
    errors.push("Beta testing requires willingness to share feedback — choose Yes.");
  }
  if (!consent) errors.push("Please accept the beta consent checkbox.");
  return errors;
}
